export const isFresh = (lastFetched, ttlMs) => {
  if (!lastFetched) return false;
  return Date.now() - lastFetched < ttlMs;
};

